import React from 'react';
import replaceTemplating from '../replaceTemplating';
function processText(text, props) {
  const regexp = /{{{(.*?)}}}/g;
  let output = text;
  if (typeof text === 'string') {
    const replacements = text.match(regexp);
    output = replaceTemplating(text, replacements, props);
  }
  if (typeof output === 'string') {
    output = output.split('\n').flatMap((output, i) => [i > 0 && React.createElement("br", {
      key: i
    }), output]);
  } else {
    output = 'There was a problem rendering the terms and conditions. Please check again later.';
  }
  return output;
}
export default processText;